import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { findMenuItemByLink, getTokenData, isTokenExpired } from '../utils/utils';
import { menuList } from '@/utils/menuhelper';
// import VueApexCharts from 'vue-apexcharts';
// Vue.use(VueApexCharts);

// Vue.component('apexchart', VueApexCharts);

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Home',
    component: () => import('./../modules/login/index.vue'),
    children: [
      {
        path: '',
        component: () => import('./../modules/login/components/index.vue'),
      },
    ],
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('./../layout/index.vue'),
    children: [
      {
        path: '/',
        redirect: '/dashboard',
      },
      {

        path: 'dashboard',
        component: () => import('./../modules/dashboard/index.vue'),
        meta: {
          accessRoleId: [1, 2, 3, 4, 5, 6, 7, 8],
          pageTitle: 'Dashboard',
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Dashboard', disabled: true },
          ],
        },
      },
      {
        path: 'locations',
        component: () => import('./../modules/locations/locations.vue'),
        meta: {
          accessRoleId: [1, 2],
          pageTitle: 'Locations',
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Masters', disabled: true },
            { text: 'Locations', disabled: true },
          ],
          // actions: [
          //   { icon: 'mdi-domain', emitter: 'location-domain-click' },
          //   { icon: 'mdi-dialpad', emitter: 'location-dialpad-click' },
          //   { icon: 'mdi-email', emitter: 'location-email-click' },
          //   { icon: 'mdi-call-split', emitter: 'location-callsplit-click' },
          //   {
          //     icon: 'mdi-arrow-up-bold-box-outline',
          //     emitter: 'location-arrowup-click',
          //   },
          // ],
        },
      },
      {
        path: 'branches',
        component: () => import('./../modules/branches/branches.vue'),
        meta: {
          pageTitle: 'Branches',
          accessRoleId: [1, 2, 3],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Masters', disabled: true },
            { text: 'Branches', disabled: true },
          ],
        },
      },
      {
        path: 'godowns',
        component: () => import('./../modules/godown/godown.vue'),
        meta: {
          pageTitle: 'Godowns',
          accessRoleId: [1, 2, 3, 4],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Masters', disabled: true },
            { text: 'Godowns', disabled: true },
          ],
        },
      },
      {
        path: 'content',
        component: () => import('./../modules/content/content.vue'),
        meta: {
          pageTitle: 'Content',
          accessRoleId: [1, 2, 3, 4, 5, 6],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Masters', disabled: true },
            { text: 'Content', disabled: true },
          ],
        },
      },
      {
        path: 'designation',
        component: () => import('./../modules/designation/designation.vue'),
        meta: {
          pageTitle: 'Designation',
          accessRoleId: [1, 2],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Masters', disabled: true },
            { text: 'Designation', disabled: true },
          ],
        },
      },
      {
        path: 'employees',
        component: () => import('./../modules/employees/employees.vue'),
        meta: {
          pageTitle: 'Employees',
          accessRoleId: [1, 2, 3],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Masters', disabled: true },
            { text: 'Employees', disabled: true },
          ],
        },
      },
      {
        path: 'customers',
        component: () => import('./../modules/customers/customers.vue'),
        meta: {
          accessRoleId: [1, 2],
          pageTitle: 'Customers',
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Masters', disabled: true },
            { text: 'Customers', disabled: true },
          ],
        },
      },
      {
        path: 'vehicles',
        component: () => import('./../modules/vehicles/vehicles.vue'),
        meta: {
          accessRoleId: [1, 2],
          pageTitle: 'Vehicles',
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Masters', disabled: true },
            { text: 'Vehicles', disabled: true },
          ],
        },
      },
      {
        path: 'users',
        component: () => import('./../modules/users/users.vue'),
        meta: {
          accessRoleId: [1, 2, 3],
          pageTitle: 'Users',
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Masters', disabled: true },
            { text: 'Users', disabled: true },
          ],
        },
      },
      {
        path: 'lr',
        component: () => import('./../modules/lr/lrs.vue'),
        meta: {
          pageTitle: 'LR',
          accessRoleId: [1, 2, 3, 4, 5, 6],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Entries', disabled: true },
            { text: 'Lr', disabled: true },
          ],
        },
      },
      {
        path: 'memo',
        component: () => import('./../modules/memo/memos.vue'),
        meta: {
          pageTitle: 'Memo',
          accessRoleId: [1, 2, 3, 4, 5, 6],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Entries', disabled: true },
            { text: 'Memo', disabled: true },
          ],
        },
      },
      {
        path: 'expense',
        component: () => import('./../modules/expenses/expenses.vue'),
        meta: {
          pageTitle: 'Expenses',
          accessRoleId: [1, 2, 3, 4, 5, 6],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Entries', disabled: true },
            { text: 'Expenses', disabled: true },
          ],
        },
      },
      {
        path: 'freightreceipt',
        component: () =>
          import('./../modules/freightreceipt/freightreceipt.vue'),
        meta: {
          pageTitle: 'Freight Receipt Generate',
          accessRoleId: [1, 2, 3, 4, 5, 6],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Transactions', disabled: true },
            { text: 'Freight Receipt Generate', disabled: true },
          ],
        },
      },
      {
        path: 'freightupdate',
        component: () =>
          import('./../modules/freightreceipt/freightupdate.vue'),
        meta: {
          pageTitle: 'Freight Payment Update',
          accessRoleId: [1, 2, 3, 4, 5, 6],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Transactions', disabled: true },
            { text: 'Freight Payment Update', disabled: true },
          ],
        },
      },
      {
        path: 'lrstatusupdate',
        component: () =>
          import('./../modules/lr/lrstatus-update.vue'),
        meta: {
          accessRoleId: [1, 2, 3, 4, 5],
          pageTitle: 'Lr Status Update',
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Details', disabled: true },
            { text: 'Lr Status Update', disabled: true },
          ],
        },
      },
      {
        path: 'lrsearch',
        component: () =>
          import('./../modules/lr/lrsearch.vue'),
        meta: {
          pageTitle: 'Lr Search',
          accessRoleId: [1, 2, 3, 4, 5, 6],
          breadcrumb: [
            { text: 'Home', href: '/', disabled: false },
            { text: 'Details', disabled: true },
            { text: 'Lr Search', disabled: true },
          ],
        },
      },
      {
        path: 'reports',
        name: 'Reports',
        component: () => import('./../modules/reports/reportsContainer.vue'),
        children: [
          {
            path: 'dds',
            component: () => import('./../modules/reports/dds.vue'),
            meta: {
              pageTitle: 'Daily Delivery Statement',
              accessRoleId: [1, 2, 3, 4, 5, 6],
              breadcrumb: [
                { text: 'Home', href: '/', disabled: false },
                { text: 'Reports', disabled: true },
                { text: 'DDS', disabled: true },
              ],
            },
          },
          {
            path: 'agentreport',
            component: () => import('./../modules/reports/agentreport.vue'),
            meta: {
              pageTitle: 'Agent Report',
              accessRoleId: [1, 2, 3, 4, 5, 6],
              breadcrumb: [
                { text: 'Home', href: '/', disabled: false },
                { text: 'Reports', disabled: true },
                { text: 'Agent Report', disabled: true },
              ],
            },
          },
          {
            path: 'pendinggoods',
            component: () => import('./../modules/reports/pendinggoods.vue'),
            meta: {
              pageTitle: 'Pending Consignments',
              accessRoleId: [1, 2, 3, 4, 5, 6],
              breadcrumb: [
                { text: 'Home', href: '/', disabled: false },
                { text: 'Reports', disabled: true },
                { text: 'Pending Consignments', disabled: true },
              ],
            },
          },
          {
            path: 'pendingdues',
            component: () => import('./../modules/reports/pendingdues.vue'),
            meta: {
              pageTitle: 'Pending Dues',
              accessRoleId: [1, 2, 3, 4, 5, 6],
              breadcrumb: [
                { text: 'Home', href: '/', disabled: false },
                { text: 'Reports', disabled: true },
                { text: 'Pending Dues', disabled: true },
              ],
            },
          },
          {
            path: 'invoices',
            component: () => import('./../modules/reports/invoices.vue'),
            meta: {
              pageTitle: 'Invoices',
              accessRoleId: [1, 2, 3, 4, 5, 6],
              breadcrumb: [
                { text: 'Home', href: '/', disabled: false },
                { text: 'Reports', disabled: true },
                { text: 'Invoice', disabled: true },
              ],
            },
          },
          {
            path: 'serialnumber',
            component: () => import('./../modules/branchseries/branchseries.vue'),
            meta: {
              pageTitle: 'Branch Series No',
              accessRoleId: [1, 2],
              breadcrumb: [
                { text: 'Home', href: '/', disabled: false },
                { text: 'Reports', disabled: true },
                { text: 'Branch Series No', disabled: true },
              ],
            },
          },
        ],
      },
      {
        path: 'support',
        name: 'Support',
        component: () => import('./../modules/helpers/support.vue'),
      },
      {
        path: 'unauthorized',
        name: 'unauthorized',
        component: () => import('./../modules/helpers/unauthorized.vue'),
      },

      {
        path: '*',
        component: () => import('./../modules/utils/404.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const routeLink = to.path;
  const menuItem = findMenuItemByLink(menuList, routeLink) || null;

  const token = localStorage.getItem('token');
  if (token && isTokenExpired(token)) {
    sessionStorage.removeItem('token');
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    window.location.replace('/login');
  }

  const tokenData = getTokenData(token) as { roleId: number };
  if (token && menuItem && !menuItem.accessRoleId.includes(tokenData?.roleId) && routeLink !== '/unauthorized') {
    // next('/unauthorized');
    window.location.replace('/unauthorized');
  }
  next();
});

export default router;
